package com.milta.core.localization.translations.es

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Dirección de carga",
    emptyMessage = "Para optimizar la ruta, indique dónde cargan la mercancía sus conductores. Se guardará para sus próximas rutas.",
    selectPlaceholder = "Elegir una dirección de carga",
    sheetSubtitle = "Donde sus conductores recogen la mercancía.",
    startPointBadge = "Punto de partida",
    newAddressAction = "Nueva dirección",
    mobileSearchPlaceholder = "Calle, número, municipio",
    webSearchPlaceholder = "Buscar una dirección…",
    deleteDialogTitle = "¿Eliminar esta dirección?",
    deleteDialogMessage = "«%s» ya no se propondrá. Las rutas ya creadas no cambian.",
    webSubmitBlockedHint = "Elija una dirección de carga para optimizar.",
    errorRequired = "Elija una dirección de carga.",
)
